/**
 * Tous les montants circulent en cents USD (entiers). L'euro est une
 * projection d'affichage recalculee au taux du jour, jamais une valeur stockee.
 */
/** Taux de repli si la table ExchangeRate est vide. Spec § 2.1. */
export const DEFAULT_EUR_RATE = 0.92;
export function usd(amount) {
    return Math.round(amount * 100);
}
export function toUsdUnits(cents) {
    return cents / 100;
}
/**
 * Spec § 2.1 : « EUR (x 0,92, arrondi a l'unite) ». L'arrondi porte sur l'euro
 * entier, pas sur le cent — 49 $ donnent 45 EUR, pas 45,08 EUR.
 */
export function usdCentsToEurCents(cents, rate = DEFAULT_EUR_RATE) {
    return Math.round((cents / 100) * rate) * 100;
}
export function convert(cents, currency, rate = DEFAULT_EUR_RATE) {
    return currency === 'USD' ? cents : usdCentsToEurCents(cents, rate);
}
const SYMBOLS = { USD: '$', EUR: '€' };
/** Format boutique : pas de decimales quand le montant est rond, comme la maquette. */
export function formatMoney(cents, currency = 'USD') {
    const units = cents / 100;
    const body = Number.isInteger(units) ? String(units) : units.toFixed(2);
    return currency === 'USD' ? `${SYMBOLS.USD}${body}` : `${body} ${SYMBOLS.EUR}`;
}
/** Affiche un prix deja converti dans la devise demandee. */
export function formatConverted(cents, currency, rate = DEFAULT_EUR_RATE) {
    return formatMoney(convert(cents, currency, rate), currency);
}
//# sourceMappingURL=money.js.map